export default {
    reportPreviewCols: [
        {
            index: 1,
            name: 'dashboard.reportPreviewCols.title',
        },
        {
            index: 2,
            name: 'dashboard.reportPreviewCols.spentTime',
        },
        {
            index: 3,
            name: 'dashboard.reportPreviewCols.date',
        },
    ],
    taskCols: [
        {
            index: 1,
            name: 'tasks.tableCols.#',
        },
        {
            index: 2,
            name: 'tasks.tableCols.title',
        },
        {
            index: 3,
            name: 'tasks.tableCols.project',
        },
        {
            index: 4,
            name: 'tasks.tableCols.status',
        },
        {
            index: 5,
            name: 'tasks.tableCols.dateEnding',
        },
        // {
        //     index: 6,
        //     name: 'tasks.tableCols.actions',
        // },
    ],
    projectsProfileCols: [
        {
            index: 1,
            name: 'profile.projects.#',
        },
        {
            index: 2,
            name: 'profile.projects.project',
        },
        {
            index: 3,
            name: 'profile.projects.role',
        },
    ],
    clientsProfileCols: [
        {
            index: 1,
            name: 'profile.clients.#',
        },
        {
            index: 2,
            name: 'profile.clients.name',
        },
        {
            index: 3,
            name: 'profile.clients.email',
        },
        {
            index: 4,
            name: 'profile.clients.phone',
        },
    ],
    dashboardCols: [
        {
            id: 1,
            title: 'dashboard.tableCols.#',
        },
        {
            id: 2,
            title: 'dashboard.tableCols.title',
        },
        {
            id: 3,
            title: 'dashboard.tableCols.project',
        },
        {
            id: 4,
            title: 'dashboard.tableCols.status',
        },
        {
            id: 5,
            title: 'dashboard.tableCols.estimate',
        },
        {
            id: 6,
            title: 'dashboard.tableCols.dateEnding',
        },
        {
            id: 7,
            title: 'dashboard.tableCols.actions',
        },
    ],
    authorCols: [
        {
            index: 1,
            name: 'authors.tableCols.#',
        },
        {
            index: 2,
            name: 'authors.tableCols.authorName',
        },
        {
            index: 3,
            name: 'authors.tableCols.actions',
        },
    ],
    bookCols: [
        {
            index: 1,
            name: 'books.tableCols.#',
        },
        {
            index: 2,
            name: 'books.tableCols.title',
        },
        {
            index: 3,
            name: 'books.tableCols.cover',
        },
        {
            index: 4,
            name: 'books.tableCols.authors',
        },
        {
            index: 5,
            name: 'books.tableCols.status',
        },
        {
            index: 6,
            name: 'books.tableCols.actions',
        },
    ],
    bugCols: [
        {
            index: 1,
            name: 'bugs.tableCols.#',
        },
        {
            index: 2,
            name: 'bugs.tableCols.type',
        },
        {
            index: 3,
            name: 'bugs.tableCols.title',
        },
        {
            index: 4,
            name: 'bugs.tableCols.status',
        },
        {
            index: 5,
            name: 'bugs.tableCols.author',
        },
        {
            index: 6,
            name: 'bugs.tableCols.dateEnding',
        },
        {
            index: 7,
            name: 'bugs.tableCols.actions',
        },
    ],
    currencyCols: [
        {
            id: 1,
            name: 'Дата начала',
        },
        {
            id: 2,
            name: 'Дата завершения',
        },
        {
            id: 3,
            name: 'Из',
        },
        {
            id: 4,
            name: 'В',
        },
        {
            id: 5,
            name: 'Курс покупки',
        },
        {
            id: 6,
            name: 'Курс продажи',
        },
    ],
    docTypesCols: [
        {
            index: 1,
            name: 'docTypes.tableCols.#',
        },
        {
            index: 2,
            name: 'docTypes.tableCols.title',
        },
        {
            index: 3,
            name: 'docTypes.tableCols.description',
        },
        {
            index: 4,
            name: 'docTypes.tableCols.actions',
        },
    ],
    documentCols: [
        {
            index: 1,
            name: 'documents.tableCols.#',
        },
        {
            index: 2,
            name: 'documents.tableCols.title',
        },
        {
            index: 3,
            name: 'documents.tableCols.docType',
        },
        {
            index: 4,
            name: 'documents.tableCols.link',
        },
        {
            index: 5,
            name: 'documents.tableCols.actions',
        },
    ],
    projectCols: [
        {
            index: 1,
            name: 'projects.inactiveTableCols.#',
        },
        {
            index: 2,
            name: 'projects.inactiveTableCols.title',
        },
        {
            index: 3,
            name: 'projects.inactiveTableCols.client',
        },
    ],
    vacationCols: [
        {
            index: 1,
            name: 'getVacation.tableCols.date',
        },
        {
            index: 2,
            name: 'getVacation.tableCols.paid',
        },
        {
            index: 3,
            name: 'getVacation.tableCols.worker',
        },
        {
            index: 4,
            name: 'getVacation.tableCols.created',
        },
        {
            index: 5,
            name: 'getVacation.tableCols.workingDaysTaken',
        },
        {
            index: 6,
            name: 'getVacation.tableCols.status',
        },
    ],
    vacationProfileCols: [
        {
            index: 1,
            name: 'vacation.tableCols.date',
        },
        {
            index: 2,
            name: 'vacation.tableCols.paid',
        },
        {
            index: 3,
            name: 'vacation.tableCols.created',
        },
        {
            index: 3,
            name: 'vacation.tableCols.type',
        },
        {
            index: 4,
            name: 'vacation.tableCols.workingDaysTaken',
        },
        {
            index: 5,
            name: 'vacation.tableCols.status',
        },
    ],
    wikiCols: [
        {
            index: 1,
            name: 'wiki.tableCols.#',
        },
        {
            index: 2,
            name: 'wiki.tableCols.title',
        },
        {
            index: 3,
            name: 'wiki.tableCols.author',
        },
        {
            index: 4,
            name: 'wiki.tableCols.actions',
        },
    ],
    attendanceCols: [
        {
            index: 2,
            name: 'attendance.tableCols.userName',
        },
        {
            index: 3,
            name: 'attendance.tableCols.beginWorkingDay',
        },
        {
            index: 4,
            name: 'attendance.tableCols.endWorkingDay',
        },
        {
            index: 5,
            name: 'attendance.tableCols.summaryPauses',
        },
        {
            index: 6,
            name: 'attendance.tableCols.summaryTime',
        },
        {
            index: 7,
            name: 'attendance.tableCols.aberration',
        },
        {
            index: 8,
            name: 'attendance.tableCols.report',
        },
    ],
    reportCols: [
        {
            index: 1,
            name: 'attendance.reportCols.project',
        },
        {
            index: 2,
            name: 'attendance.reportCols.task',
        },
        {
            index: 3,
            name: 'attendance.reportCols.report',
        },
        {
            index: 4,
            name: 'attendance.reportCols.time',
        },
    ],
    generalReportCols: [
        {
            index: 1,
            name: 'attendance.generalReportCols.userName',
        },
        {
            index: 2,
            name: 'attendance.generalReportCols.spentHours',
        },
        {
            index: 3,
            name: 'attendance.generalReportCols.plannedHours',
        },
        {
            index: 4,
            name: 'attendance.generalReportCols.aberration',
        },
    ],
    candidateCols: [
        {
            index: 0,
            name: '№',
        },
        {
            index: 1,
            name: 'hr.candidateCols.fullName',
        },
        {
            index: 2,
            name: 'hr.candidateCols.stack',
        },
        {
            index: 3,
            name: 'hr.candidateCols.english',
        },
        {
            index: 4,
            name: 'hr.candidateCols.salary',
        },
        {
            index: 5,
            name: 'hr.candidateCols.cv',
        },
        {
            index: 6,
            name: 'hr.candidateCols.lastConnect',
        },
        {
            index: 7,
            name: 'hr.candidateCols.comments',
        },
        {
            index: 8,
            name: 'hr.candidateCols.actions',
        },
    ],
    onboardingTaskCols: [
        {
            index: 1,
            name: 'onboarding.tableCols.#',
        },
        {
            index: 2,
            name: 'onboarding.tableCols.role',
        },
        {
            index: 3,
            name: 'onboarding.tableCols.project',
        },
        {
            index: 4,
            name: 'onboarding.tableCols.priority',
        },
        {
            index: 5,
            name: 'onboarding.tableCols.defaultStatus',
        },
        {
            index: 6,
            name: 'onboarding.tableCols.title',
        },
        {
            index: 7,
            name: 'onboarding.tableCols.description',
        },
        {
            index: 8,
            name: 'onboarding.tableCols.actions',
        },
    ],
}
